module.exports = __webpack_public_path__ + "static/templates/bulk-upload-ms.2rY5EFZ.xlsx";